import {Action} from '@ngrx/store';
import {Demo} from '../demo.model';
import {Profile} from '../../profile/profile.model';

export const GET_DEMO_LIST = 'GET_DEMO_LIST';
export const SET_DEMO_LIST = 'SET_DEMO_LIST';
export const ADD_DEMO_AUDIT = 'ADD_DEMO_AUDIT';
export const GET_DEMO = 'GET_DEMO';

export const SET_CHARTS_RELOAD = 'SET_CHARTS_RELOAD_DEMO';
export const SET_AUDIT = 'SET_AUDIT_DEMO';
export const SET_AUDIENCE_STAT = 'SET_AUDIENCE_STAT_DEMO';
export const SET_AUDIENCE_INTEREST = 'SET_AUDIENCE_INTEREST_DEMO';
export const SET_AUDIENCE_LOCATION = 'SET_AUDIENCE_LOCATION_DEMO';
export const SET_FOLLOWER_STAT = 'SET_FOLLOWER_STAT_DEMO';
export const SET_FOLLOWER_ENGAGE = 'SET_FOLLOWER_ENGAGE_DEMO';
export const SET_FOLLOWER_ENGAGE_INDICATOR = 'SET_FOLLOWER_ENGAGE_INDICATOR_DEMO';
export const SET_MEDIA_STAT = 'SET_MEDIA_STAT_DEMO';
export const SET_MEDIA_ANALYZE = 'SET_MEDIA_ANALYZE_DEMO';
export const SET_MEDIA_COMMENT_ANALYZE = 'SET_MEDIA_COMMENT_ANALYZE_DEMO';
export const SET_PROFILE_DETAIL = 'SET_PROFILE_DETAIL_DEMO';
export const SET_PROFILE_PROGRESS = 'SET_PROFILE_PROGRESS_DEMO';
export const SET_LOADER = 'SET_LOADER_DEMO';
export const SET_AUTOLOAD = 'SET_AUTOLOAD_DEMO';
export const SET_PROFILE_MEDIA = 'SET_PROFILE_MEDIA_DEMO';
export const SET_PROFILE_SCORE = 'SET_PROFILE_SCORE_DEMO';

export class GetDemoList implements Action {
  readonly type = GET_DEMO_LIST;

  constructor(public payload: number) {}
}

export class SetDemoList implements Action {
  readonly type = SET_DEMO_LIST;

  constructor(public payload: Demo[]) {}
}

export class AddDemoAudit implements Action {
  readonly type = ADD_DEMO_AUDIT;

  constructor(public payload: Demo) {}
}

export class GetDemo implements Action {
  readonly type = GET_DEMO;

  constructor(public payload: {
    id: string,
    saveAsDemo: boolean
  }) {}
}

// demo data
export class SetChartsReload implements Action {
  readonly type = SET_CHARTS_RELOAD;

  constructor(public payload: string) {}
}

export class SetAudit implements Action {
  readonly type = SET_AUDIT;

  constructor(public payload: Profile) {}
}

export class SetAudienceStat implements Action {
  readonly type = SET_AUDIENCE_STAT;

  constructor(public payload: any) {}
}

export class SetAudienceInterest implements Action {
  readonly type = SET_AUDIENCE_INTEREST;

  constructor(public payload: any) {
  }
}

export class SetAudienceLocation implements Action {
  readonly type = SET_AUDIENCE_LOCATION;

  constructor(public payload: any) {
  }
}

export class SetFollowerStat implements Action {
  readonly type = SET_FOLLOWER_STAT;

  constructor(public payload: any) {}
}

export class SetFollowerEngage implements Action {
  readonly type = SET_FOLLOWER_ENGAGE;

  constructor(public payload: any) {
  }
}

export class SetFollowerEngageIndicator implements Action {
  readonly type = SET_FOLLOWER_ENGAGE_INDICATOR;

  constructor(public payload: any) {
  }
}

export class SetMediaStat implements Action {
  readonly type = SET_MEDIA_STAT;

  constructor(public payload: any) {}
}

export class SetMediaAnalyze implements Action {
  readonly type = SET_MEDIA_ANALYZE;

  constructor(public payload: any) {
  }
}

export class SetMediaCommentAnalyze implements Action {
  readonly type = SET_MEDIA_COMMENT_ANALYZE;

  constructor(public payload: any) {
  }
}

export class SetProfileDetail implements Action {
  readonly type = SET_PROFILE_DETAIL;

  constructor(public payload: any) {
  }
}

export class SetProfileProgress implements Action {
  readonly type = SET_PROFILE_PROGRESS;

  constructor(public payload: any) {
  }
}

export class SetLoader implements Action {
  readonly type = SET_LOADER;

  constructor(public payload: {module: string, box: string, value: boolean}) {}
}

export class SetAutoload implements Action {
  readonly type = SET_AUTOLOAD;

  constructor(public payload: boolean) {}
}

export class SetProfileMedia implements Action {
  readonly type = SET_PROFILE_MEDIA;

  constructor(public payload: any[]) {}
}

export class SetProfileScore implements Action {
  readonly type = SET_PROFILE_SCORE;

  constructor(public payload: any) {}
}

export type DemoActions = GetDemoList | SetDemoList | AddDemoAudit | GetDemo
  | SetAudit | SetAudienceStat | SetAudienceInterest | SetAudienceLocation | SetFollowerStat | SetFollowerEngage
  | SetFollowerEngageIndicator | SetMediaStat | SetMediaAnalyze | SetMediaCommentAnalyze | SetProfileDetail
  | SetProfileProgress | SetLoader | SetAutoload | SetProfileMedia | SetProfileScore | SetChartsReload
  ;
